function getIconClassName(
  chroma: string,
  size: string,
  style: Record<string, string>
) {
  if (size === 'small' && chroma === 'light') {
    return style.svgLight24;
  }

  if (size === 'small' && chroma === 'dark') {
    return style.svgDark24;
  }

  if (size === 'large' && chroma === 'light') {
    return style.svgLight32;
  }

  if (size === 'large' && chroma === 'dark') {
    return style.svgDark32;
  }

  return null;
}

export default getIconClassName;
